import { IconCircle } from 'foundations-components/transitional/components/IconCircle';
import { jsx as _jsx } from "react/jsx-runtime";
const MatchStatusIconCircle = props => {
  const {
    matchData
  } = props;
  if (!matchData) {
    return null;
  }
  return /*#__PURE__*/_jsx(IconCircle, {
    backgroundColor: matchData.iconColor,
    borderWidth: "0",
    color: 'icon-primary-on-fill-default',
    icon: matchData.IconComponent,
    padding: "50",
    marginInlineEnd: "100",
    verticalAlign: 'text-top'
  });
};
export default MatchStatusIconCircle;